import { render, staticRenderFns } from "./ReportGeneration.vue?vue&type=template&id=96104982&scoped=true"
import script from "./ReportGeneration.vue?vue&type=script&lang=js"
export * from "./ReportGeneration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96104982",
  null
  
)

export default component.exports